import React, { useState } from 'react'

interface CollapsibleSectionProps {
  title: string
  subtitle?: string
  count: number
  defaultExpanded?: boolean
  variant?: 'live' | 'completed' | 'upcoming'
  children: React.ReactNode
}

export function CollapsibleSection({
  title,
  subtitle,
  count,
  defaultExpanded = true,
  variant = 'upcoming',
  children,
}: CollapsibleSectionProps) {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded)

  return (
    <div className={`collapsible-section ${variant} ${isExpanded ? 'expanded' : 'collapsed'}`}>
      <button
        className="collapsible-header"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <div className="collapsible-title-group">
          <div className="h1">{title}</div>
          {subtitle && <div className="h2">{subtitle}</div>}
        </div>
        <div className="collapsible-meta">
          <span className="pill">{count}</span>
          <svg
            className={`collapsible-chevron ${isExpanded ? 'expanded' : ''}`}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="6 9 12 15 18 9" />
          </svg>
        </div>
      </button>
      <div className={`collapsible-content ${isExpanded ? 'expanded' : ''}`}>
        {children}
      </div>
    </div>
  )
}
